import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { startCase } from 'lodash';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useFormState } from 'modules/taboola-common-frontend-modules/forms';
import { LANDING_PAGES_ROUTE } from '../config';
import { duplicateLandingPage } from '../flows/duplicateLandingPage';

export const useDuplicateLandingPageState = ({ onClose, initialData }) => {
    const { submit } = useFormState({ waitAccountFetched: false });
    const { accountName } = useAccount();
    const dispatch = useDispatch();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = useCallback(async () => {
        try {
            setIsSubmitting(true);

            const result = await submit({
                saveFormData: async landingPage => {
                    const { title } = landingPage;

                    if (!title?.trim()) {
                        throw new Error('Landing page title is required');
                    }

                    // Transform title from kebab-case (form format) to startCase (backend format)
                    const duplicatePayload = {
                        accountName,
                        title: startCase(title.trim()),
                        ...initialData,
                    };

                    const duplicatedLandingPage = await dispatch(duplicateLandingPage(duplicatePayload));
                    return duplicatedLandingPage;
                },
                successUrl: LANDING_PAGES_ROUTE,
            });

            if (result) {
                onClose({ confirmed: true, landingPage: result });
            }
        } catch (error) {
            console.error('Error in handleSubmit:', error);
            throw error;
        } finally {
            setIsSubmitting(false);
        }
    }, [submit, dispatch, accountName, initialData, onClose]);

    const handleCancel = useCallback(() => {
        onClose({ confirmed: false });
    }, [onClose]);

    return {
        handleSubmit,
        handleCancel,
        isSubmitting,
    };
};
